import { CanActivateFn, Router } from '@angular/router';
import { inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { ProfileSelectors, ProfileStoreState } from "../../core/store/profile";
import { map } from "rxjs/operators";
import { Role } from "../../api/models/fraud.models";
import { VariablesService } from "../services/variables.service";

export const rolesGuard = (accessRoles: Role[]): CanActivateFn => (route, state) => {
    const router: Router = inject(Router);
    const variablesService = inject(VariablesService);
    const role = variablesService.role();

    if (!role) {
        return router.createUrlTree(['/something-went-wrong']);
    }

    if (accessRoles.includes(role)) {
        return true;
    }

    return router.createUrlTree(['/something-went-wrong']);
};
